import Axios, { AxiosRequestConfig } from "axios";

import { getUser } from "./ssr/user";

const basePath =
  process.env.NEXT_PUBLIC_API_BASEPATH ??
  "https://referral-backend.network.seeblindspot.com/";

// const basePath = 'http://localhost:8000/v1';
const API: any = async (
  request: AxiosRequestConfig,
  otherOption?: any
): Promise<any> => {
  const options: AxiosRequestConfig = {
    baseURL: basePath,
    timeout: 60000,
    ...otherOption,
  };
  if (request.cancelToken) options.cancelToken = request.cancelToken;

  const client = Axios.create(options);
  const jwt = await getUser();
  if (jwt) client.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
  // TODO add custom interceptors
  return client.request(request);
};

export default API;
